import * as React from 'react';
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";

import {Dialogs} from "./types";

interface FooterProps {
    onSubmit: (event: React.MouseEvent<HTMLButtonElement>) => void,
    onHide: () => void
    disabled: boolean
}

const Footer = ({onSubmit, onHide, disabled = false}: FooterProps) => {
    return (
        <div>
            <Button label='Закрыть' className={'p-button-secondary'} onClick={onHide} />
            <Button disabled={disabled} label='Отправить' className={'p-button-danger'} onClick={onSubmit} />
        </div>
    )
}

interface State {
    comment: string
}

interface Props extends Dialogs {
    onSubmit: (accept: boolean, comment: string) => void
}

export class RejectRequestDialog extends React.Component<Props, State> {
    state = {
        comment: ''
    }

    handleTextarea = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        this.setState({comment: event.currentTarget.value})
    }

    handleSubmit = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        this.props.onSubmit(false, this.state.comment);
        window.history.back();
    }

    render() {
        return (
            <Dialog
                header="Причина"
                className='custom-dialog'
                visible={this.props.visible}
                onHide={this.props.onHide}
                closable={false}
                draggable={false}
                style={{maxWidth: '700px', width: '100%'}}
                footer={Footer({
                    onSubmit: this.handleSubmit,
                    onHide: this.props.onHide,
                    disabled: !this.state.comment.length
                })}
            >
                <div className="form-group">
                    <textarea
                        className="form-control"
                        value={this.state.comment}
                        onChange={this.handleTextarea}
                        placeholder={'Введите причину отказа'}
                    />
                </div>
            </Dialog>
        );
    }
}

